/**
 * Types Field Enum
 */
export const PhoneDefaultPrefixEnum = Object.freeze({
  FORMAT_1: /(\d{3})(\d{2})(\d{2})(\d{2})/,
  FORMAT_2: '$1 $2 $3 $4',
  MAX_LENGTH: 9,
  CODE: '+33',
  VALUE: 'FR',
});
